import { useMutation } from 'react-query';
import { useAppContext } from '../../context/app';
import { useAxiosInstance } from '../common';

const endpoint = '/authentication/request_password_reset';

interface ResetPasswordFormValues {
  email: string;
}

const useRequestPasswordReset = () => {
  const { dispatch } = useAppContext();
  const axios = useAxiosInstance();

  return useMutation(async (passwordResetRequestData: ResetPasswordFormValues) => { 
    await axios.post<any>(endpoint, {}, {params: passwordResetRequestData});
    dispatch({
        type: 'SHOW_NOTIFICATION',
        payload: { notification: { type: 'success', content: 'Successfully sent password reset email.' } },
      });
  });
};

export default useRequestPasswordReset;